"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = void 0;
const slate_hyperscript_1 = require("slate-hyperscript");
function deserialize(node) {
    var _a, _b;
    if (node.nodeType === Node.TEXT_NODE) {
        /**
         * The actual Text inside an Element or Attr.
         */
        return (_a = node === null || node === void 0 ? void 0 : node.textContent) !== null && _a !== void 0 ? _a : '';
    }
    else if (node.nodeType !== Node.ELEMENT_NODE) {
        /**
         * An Element node like <p> or <div>.
         */
        return '';
    }
    let children = Array.from(node.childNodes).map((node) => deserialize(node));
    if (children.length === 0) {
        children = [{ text: '' }];
    }
    switch (node.nodeName) {
        case 'BODY':
            return slate_hyperscript_1.jsx('fragment', {}, children);
        case 'BR':
            return '\n';
        case 'UL':
            return slate_hyperscript_1.jsx('element', { type: 'bulleted-list' }, children);
        case 'OL':
            return slate_hyperscript_1.jsx('element', { type: 'numbered-list' }, children);
        case 'LI':
            return slate_hyperscript_1.jsx('element', { type: 'list-item' }, children);
        case 'STRONG':
            return slate_hyperscript_1.jsx('text', { type: 'bold', bold: true }, children);
        case 'EM':
            return slate_hyperscript_1.jsx('text', { type: 'italic', italic: true }, children);
        case 'U':
            return slate_hyperscript_1.jsx('text', { type: 'underline', underline: true }, children);
        case 'CODE':
            return slate_hyperscript_1.jsx('text', { type: 'code', code: true }, children);
        case 'A':
            return slate_hyperscript_1.jsx('text', {
                type: 'link',
                link: {
                    url: node.getAttribute('href'),
                    name: node.getAttribute('data-name'),
                    contentType: node.getAttribute('data-content-type'),
                    size: node.getAttribute('data-size'),
                },
            }, children);
        case 'P':
            return slate_hyperscript_1.jsx('element', { type: 'paragraph' }, children);
        case 'BLOCKQUOTE':
            return slate_hyperscript_1.jsx('element', { type: 'block-quote' }, children);
        case 'H1':
            return slate_hyperscript_1.jsx('element', { type: 'heading-one' }, children);
        case 'H2':
            return slate_hyperscript_1.jsx('element', { type: 'heading-two' }, children);
        default:
            return (_b = node === null || node === void 0 ? void 0 : node.textContent) !== null && _b !== void 0 ? _b : '';
    }
}
exports.deserialize = deserialize;
//# sourceMappingURL=deserialize.js.map